import { makeStyles } from '@mui/styles';

const styles = makeStyles((theme) => {
  const themePalette = theme.palette.primary
  const themeTypography = theme.typography

  return {
    chipContainer: {
      display: 'grid',
    },
    chipComponent: {
      marginBottom: '8px',
      justifyContent: 'space-between',
      backgroundColor: themePalette.lightestGrey,
    },
    errorStyle: {
      color: `${themePalette.bostonRed} !important`,
    },
    formControl: {
      minWidth: '100px',
      margin: theme.spacing(1),
      '& label': {
        color: `${themePalette.lightGrey} !important`,
      },
      '& input, textarea': {
        color: themePalette.midGrey,
      },
    },
    formStaticWrap: {
      marginTop: '18px',
    },
    fullWidth: {
      width: '90%',
      display: 'block',
    },
    progressSpinner: {
      width: '20px !important',
      height: '20px !important',
    },
    metadataWrap: {
      padding: '5px',
      minHeight: '100%',
      height: '90vh',
      display: 'flex',
      flexDirection: 'column',
    },
    metadataScrollContent: {
      flex: 1,
      overflowY: 'auto',
      paddingBottom: '10px',
    },
    metadataFooter: {
      position: 'sticky',
      bottom: 0,
      backgroundColor: '#fff',
      padding: '16px',
      borderTop: '1px solid #e0e0e0',
      display: 'flex',
      justifyContent: 'flex-end',
      gap: '8px',
      zIndex: 10,
    },
    metadataWrapMedium: {
      padding: '10px',
    },
    metadataCard: {
      paddingTop: '20px',
    },
    librarianStatus: {
      paddingTop: '20px',
      paddingBottom: '2%',
    },
    metadataCardContent: {
      display: 'flex',
      flexWrap: 'wrap',
      paddingTop: '20px',
    },
    metadataCardActionWrapper: {
      marginLeft: '20px',
    },
    metadataDivider: {
      width: '100%',
      margin: '10px 0',
    },
    metadataSubHeading: {
      fontSize: themeTypography.pxToRem(18),
      fontWeight: themeTypography.fontWeightRegular,
    },
    radioBtn: {
      '& .C-InputRadio': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-evenly',
        width: '100%',
      },
      '& .C-InputRadio__Option': {
        color: 'black',
      },
      '& .C-InputRadio__Option__Selector': {
        background: 'unset',
      },
    },
    metadataTable: {
      margin: '0',
      padding: '0 8px',
      '& tr:last-child td': {
        borderBottom: 'none',
      },
    },
    metadataTableRow: {
      '&:hover': {
        backgroundColor: themePalette.lightestGrey,
        '& .actionBtnHover': {
          visibility: 'visible',
        },
      },
    },
    metadataTableCell: {
      flex: 1,
      padding: '0 !important',
      '& label, input': {
        fontSize: '0.8rem !important',
      },
    },
    metadataTableCellAction: {
      width: '20px',
      marginLeft: '10px',
      '& .error': {
        color: `${themePalette.bostonRed} !important`,
      },
    },
    metadataTableCellActionBtn: {
      visibility: 'hidden',
    },
    noResults: {
      width: '50%',
      textAlign: 'center',
      color: themePalette.midGrey,
      marginTop: '2%',
      fontSize: '20px',
      margin: '0 auto',
      paddingBottom: '3%',
    },
    actionsContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    actionButtonWrap: {
      display: 'flex',
      justifyContent: 'flex-end',
    },
    actionMessage: {
      color: themePalette.primaryGreen,
      display: 'flex',
      alignItems: 'center',
      marginRight: '10px',
      fontSize: 'small',
    },
    noMDAccessMessage: {
      display: 'flex',
      alignItems: 'center',
      color: themePalette.bostonRed,
      textTransform: 'capitalize',
      fontSize: '12px',
    },
    actionButtonStyle: {
      padding: '10px',
      marginLeft: '10px',
      backgroundColor: '#0288D1',
      color: '#fff',
    },
    actionButtonPrimary: {
      backgroundColor: themePalette.primaryBlue,
      color: themePalette.contrastText,
      '&:hover': {
        backgroundColor: themePalette.primaryDarkBlue,
      },
    },
    librarianCardSubHeading: {
      paddingLeft: '20px',
      paddingTop: '20px',
      fontSize: themeTypography.pxToRem(18),
      fontWeight: themeTypography.fontWeightRegular,
    },
    usageDetails: {
      fontSize: '12px',
      padding: '0px 40px 20px 40px',
    },
    usageDetailsLabel: {
      color: '#555555',
      border: 'none',
    },
    usageSummaryLabel: {
      width: 'max-content !important',
    },
    usageDetailsText: {
      color: '#212121',
      fontSize: '13px',
    },
    noBorderClass: {
      border: 'none',
    },
    usageRightsAccordion: {
      backgroundColor: '#FAFAFA',
      margin: '10px 20px !important',
    },
    goldMetaData: {
      '& .MuiCardContent-root': {
        padding: '12px',
      },
    },
  }
})

export default styles
